module.exports = __webpack_public_path__ + "static/media/icon-up.991db586.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-up.svg
// module id = 1475
// module chunks = 0